export default class DuplicateError extends Error {}
